import React, { useState } from 'react';
import Header from '../components/Header';
import IonicGridHero from '../components/IonicGridHero';
import Manifesto from '../components/Manifesto';
import Capabilities from '../components/Capabilities';
import IdealClients from '../components/IdealClients';
import VaultGallery from '../components/VaultGallery';
import SellerPortal from '../components/SellerPortal';
import Voices from '../components/Voices';
import FAQ from '../components/FAQ';
import JoinTeam from '../components/JoinTeam';
import Contact from '../components/Contact';
import Footer from '../components/Footer';
import Vault from '../components/Vault';

const HomePage = () => {
  const [vaultOpen, setVaultOpen] = useState(false);

  return (
    <>
      <Header onOpenVault={() => setVaultOpen(true)} />
      <div className="home-body">
        <main>
          <IonicGridHero onOpenVault={() => setVaultOpen(true)} />
          <Manifesto />
          <Capabilities />
          <IdealClients />
          <VaultGallery onOpenVault={() => setVaultOpen(true)} />
          <SellerPortal />
          <Voices />
          <FAQ />
          <JoinTeam />
          <Contact />
        </main>
        <Footer />
      </div>
      <Vault open={vaultOpen} onClose={() => setVaultOpen(false)} />
    </>
  );
};

export default HomePage;
